// extracted by mini-css-extract-plugin
export default {"bar":"SegmentBar_bar__oSYmc","dot":"SegmentBar_dot__PHrIf","segment":"SegmentBar_segment__XpNQf"};